import Layout from "../components/Layout";
import { useTheme } from "../context/ThemeContext";

const sections = [
  {
    icon: "📦", title: "Getting Started",
    steps: [
      "Create your business account on the Register page",
      "Log in with your email and password",
      "You will land on your Dashboard showing key business metrics",
    ],
  },
  {
    icon: "🗂️", title: "Managing Categories",
    steps: [
      "Click Categories in the sidebar",
      "Click Add Category to create product groups like Electronics, Food or Clothing",
      "Categories help you organize and filter your inventory",
    ],
  },
  {
    icon: "📋", title: "Managing Products",
    steps: [
      "Click Products in the sidebar",
      "Click Add Product to add a single product manually",
      "Fill in the product name, price, cost and stock quantity",
      "Assign a category to keep inventory organized",
      "To add many products at once click Template to download a CSV file",
      "Fill the CSV in Excel or Google Sheets then click Import CSV to upload",
      "Set a Low Stock Alert threshold so you get notified when stock runs low",
    ],
  },
  {
    icon: "💰", title: "Recording Sales",
    steps: [
      "Click Sales in the sidebar",
      "Click Record Sale to open the sales form",
      "Select the product and enter the quantity sold",
      "Add multiple items to a single sale using Add Another Item",
      "Select payment method — Cash, Bank Transfer or Card",
      "Click Record Sale — stock levels update automatically",
    ],
  },
  {
    icon: "📊", title: "Reports and Analytics",
    steps: [
      "Click Reports in the sidebar",
      "View today's sales and revenue at a glance",
      "See monthly performance summary",
      "Track your top selling products by quantity and revenue",
      "View your 30-day revenue trend on the line chart",
    ],
  },
  {
    icon: "⚠️", title: "Low Stock Alerts",
    steps: [
      "Set a low stock threshold when adding or editing a product",
      "When stock falls to or below that number an alert appears on the Dashboard",
      "The stock count turns red on the Products page as a visual warning",
      "Use the low stock alert to know when to reorder",
    ],
  },
  {
    icon: "📱", title: "Installing MartSense on Your Phone",
    steps: [
      "Open martsense.com.ng in Chrome on your Android phone",
      "Tap the three dots menu at the top right",
      "Select Add to Home Screen then tap Add",
      "MartSense will appear on your home screen like a native app",
      "On iPhone use Safari, tap the Share button then Add to Home Screen",
    ],
  },
  {
    icon: "🔐", title: "Account and Security",
    steps: [
      "To reset your password click Forgot Password on the login page",
      "Enter your email and check your inbox for a reset link",
      "The reset link expires in 60 minutes",
      "Always log out when using a shared device",
    ],
  },
];

export default function UserGuide() {
  const { theme } = useTheme();

  return (
    <Layout>
      <div style={{ marginBottom: "32px" }}>
        <h1 style={{ fontSize: "28px", fontWeight: "700", color: theme.textPrimary, letterSpacing: "-0.5px" }}>
          User Guide
        </h1>
        <p style={{ fontSize: "14px", color: theme.textSecondary, marginTop: "4px" }}>
          Everything you need to know to use MartSense
        </p>
      </div>

      <div style={{
        display: "grid",
        gridTemplateColumns: "repeat(auto-fill, minmax(300px, 1fr))",
        gap: "20px",
        marginBottom: "40px",
      }}>
        {sections.map((section) => (
          <div key={section.title} style={{
            background: theme.cardBg,
            border: `1px solid ${theme.cardBorder}`,
            borderRadius: "14px",
            padding: "24px",
            boxShadow: theme.cardShadow,
          }}>
            <div style={{ display: "flex", alignItems: "center", gap: "12px", marginBottom: "20px" }}>
              <span style={{ fontSize: "24px" }}>{section.icon}</span>
              <h2 style={{ fontSize: "16px", fontWeight: "700", color: "#2ec4b6" }}>{section.title}</h2>
            </div>
            <ol style={{ listStyle: "none", display: "flex", flexDirection: "column", gap: "12px" }}>
              {section.steps.map((step, i) => (
                <li key={i} style={{ display: "flex", gap: "12px", alignItems: "flex-start" }}>
                  <span style={{
                    background: theme.inputBg, color: "#2ec4b6",
                    borderRadius: "50%", width: "22px", height: "22px",
                    display: "flex", alignItems: "center", justifyContent: "center",
                    fontSize: "11px", fontWeight: "700", flexShrink: 0, marginTop: "1px",
                  }}>{i + 1}</span>
                  <span style={{ fontSize: "14px", color: theme.textSecondary, lineHeight: "1.6" }}>{step}</span>
                </li>
              ))}
            </ol>
          </div>
        ))}
      </div>

      <div style={{
        background: theme.cardBg,
        border: `1px solid ${theme.cardBorder}`,
        borderRadius: "14px",
        padding: "24px",
        textAlign: "center",
        boxShadow: theme.cardShadow,
      }}>
        <p style={{ fontSize: "14px", color: theme.textSecondary, marginBottom: "8px" }}>
          Need more help? Contact us at{" "}
          <a href="mailto:martsenseinfo@gmail.com" style={{ color: "#2ec4b6", textDecoration: "none", fontWeight: "600" }}>
            martsenseinfo@gmail.com
          </a>
        </p>
        <p style={{ fontSize: "12px", color: theme.textMuted }}>
          Built by StackSense Technologies Ltd — Navigating Technology | Delivering Intelligence
        </p>
      </div>
    </Layout>
  );
}